import { render } from "./DataTitle.vue?vue&type=template&id=9abbf2f0"
import script from "./DataTitle.vue?vue&type=script&lang=js"
export * from "./DataTitle.vue?vue&type=script&lang=js"
script.render = render

export default script